import { Button } from "@material-ui/core";
import { useIntl } from "react-intl";
interface IButtonLinkProps {
  className?: string;
  text?: string;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
  onClick?: () => void;
  icon?: React.ReactElement;
}
export const ButtonSubmit = (props: IButtonLinkProps) => {
  const { className, text, variant, onClick, disabled, icon } = props;
  const { formatMessage } = useIntl();
  return (
    <Button
      disabled={disabled}
      className={className}
      variant={variant || "outlined"}
      onClick={onClick}
      startIcon={icon}
      style={{padding:'16px'}}
    >
      {formatMessage({ id: text })}
    </Button>
  );
};
